import { CHARACTER_WHITESPACE } from '../../../constants/common'
import {
  formatCalendarDate,
  getCalendarCapWarningText,
} from '../Calendar.utils'

function getCalendarFollowUpCapQuestion({ dayLoad, locale, t }) {
  return dayLoad.next_free_date
    ? t('Calendar.CapConfirmQuestionKey', {
        date: formatCalendarDate({ date: dayLoad.next_free_date, locale }),
      })
    : t('Calendar.CapConfirmQuestionNoFreeDayKey')
}

export function getHasCalendarFollowUpCapColleagues(cap) {
  return Boolean(cap) && cap.colleagues.length > 0
}

export function getCalendarFollowUpCapNextFreeDate(cap) {
  return cap ? cap.dayLoad.next_free_date : null
}

export function getCalendarFollowUpCapDescription({ cap, locale, t }) {
  return [
    getCalendarCapWarningText({ dayLoad: cap.dayLoad, locale, t }),
    getCalendarFollowUpCapQuestion({ dayLoad: cap.dayLoad, locale, t }),
  ].join(CHARACTER_WHITESPACE)
}
